<div class="card-header">
  <button class="btn btn-back" type="button" title="Voltar" (click)="return($event)" *ngIf="canReturnBtn">
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </button>

  <span class="header-title"><i [ngClass]="iconCls" *ngIf="iconCls"></i> {{ title }}</span>

  <div class="header-options">
    <div class="header-search">
      <input class="form-control" placeholder="Consulta" title="Consulta" appFocus *ngIf="showSearchDefault"
        [class.no-empty]="!!searchValue" [(ngModel)]="searchValue" (keyup.enter)="executeSearch($event)">
      <button class="input-group-addon" type="button" title="Consultar" *ngIf="showSearchDefault"
        (click)="executeSearch($event)">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
      <!-- <button class="input-group-addon" type="button" title="Filtro" *ngIf="!!filter && filter.length > 0"
        (click)="openFilter($event)">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </button> -->
    </div>

    <div class="header-actions">
      <button class="btn btn-action" type="button" title="Filtro" *ngIf="!!filter && filter.length > 0"
        (click)="openFilter($event)">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </button>
      <button class="btn btn-action" type="button" *ngFor="let action of actionList"
        (click)="actionsClick.emit(action.name, $event)" [title]="action.title">
        <i *ngIf="action.icon" [class]="action.icon"></i> &nbsp;
        <span *ngIf="action.caption">{{ action.caption }}</span>
      </button>
    </div>
  </div>
</div>


<!-- <div class="card">
  <div class="card-header">
    <h4 class="card-title" id="heading-input-icon">Input With Icon</h4>
    <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
    <div class="heading-elements">
      <fieldset class="position-relative">
        <input type="text" class="form-control form-control-sm">
        <div class="form-control-position">
          <i class="fa fa-arrow-circle-o-right"></i>
        </div>
      </fieldset>
    </div>
  </div>
</div> -->


<!-- <div class="card-block header">
  <div class="return" *ngIf="canReturnBtn">
    <button type="button" class="btn btn-close" (click)="onReturn.emit($event)" title="Voltar">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
  </div>

  <h3 class="title pl-2">{{ title }}</h3>

  <div class="components no-mobile">
    <div class="actions">
      <div class="input-group search">
        <input class="form-control" placeholder="Consulta" title="Consulta" appFocus *ngIf="showSearchDefault"
          [class.no-empty]="!!searchValue" [(ngModel)]="searchValue" (keyup.enter)="executeSearch($event)">
        <button type="button" class="input-group-addon" title="Consultar" *ngIf="showSearchDefault"
          (click)="executeSearch($event)">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="input-group-addon" title="Filtro" *ngIf="!!filter" (click)="openFilter($event)">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </button>
      </div>

      <button type="button" *ngFor="let action of actionList" class="btn btn-action" title="Novo Item"
        (click)="actionsClick.emit(action.name, $event)" [title]="action.title">
        <i *ngIf="action.icon" [class]="action.icon" aria-hidden="true"></i> &nbsp;
        <span *ngIf="action.caption">{{ action.caption }}</span>
      </button>
    </div>
  </div>

  <div class="components mobile">
    <div class="actions">
      <div class="input-group search">
        <input class="form-control" placeholder="Consulta" title="Consulta" appFocus [class.no-empty]="!!searchValue"
          [(ngModel)]="searchValue" (keyup.enter)="executeSearch($event)">
        <button type="button" class="input-group-addon" title="Consultar" (click)="executeSearch($event)">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="input-group-addon" title="Filtro" *ngIf="!!filter" (click)="openFilter($event)">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </button>
      </div>

      <button type="button" *ngFor="let action of actionList" class="btn btn-action" title="Novo Item"
        (click)="actionsClick.emit(action.name, $event)" [title]="action.title">
        <i *ngIf="action.icon" [class]="action.icon" aria-hidden="true"></i>
        <span *ngIf="action.caption">{{ action.caption }}</span>
      </button>
    </div>
  </div>
</div> -->
